import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectReleaseStagePermissions } from '@app/core/permissions/project-release-stage.permissions';
import { IReleaseStageMappedItem } from '@app/logic/release-stages/interfaces/i.release-stage.mapped';
import { ReleaseStagesLogicService } from '@app/logic/release-stages/release-stages.logic.service';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { IProjectReleaseStageDefaultSupplierDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { IDefaultInstallersDialogData, ReleaseDefaultInstallerDialogComponent } from './release-default-installer-dialog/release-default-installer-dialog.component';
import { cloneDeepSafe } from '@app/shared/utils/clone-object.util';
import { take } from 'rxjs';

@Component({
    selector: 'cb-release-default-installer',
    templateUrl: './release-default-installer.component.html',
    styleUrls: ['./release-default-installer.component.scss'],
    standalone: false
})
export class ReleaseDefaultInstallerComponent implements OnInit {

    @Input() public mappedItem: IReleaseStageMappedItem;
    public loaded = false;

    constructor(
        public readonly projectReleaseStagePermissions: ProjectReleaseStagePermissions,
        public readonly cbDialog: CbDialogService,
        private readonly projectReleaseStagesLogicService: ReleaseStagesLogicService,
        private route: ActivatedRoute,
    ) { }

    public ngOnInit(): void {
        if (!this.mappedItem?.id) {
            this.route.params.pipe(take(1)).subscribe(val => {
                this.projectReleaseStagesLogicService.$getMappedItem(val.releaseId).pipe(take(1)).subscribe(result => {
                    this.mappedItem = result;
                    this.loaded = true;
                });
            });
        } else {
            this.loaded = true;
        }
    }

    public dialog(defaultInstaller?: IProjectReleaseStageDefaultSupplierDto, idx?: number): void {
        this.cbDialog
            .open<IDefaultInstallersDialogData, IProjectReleaseStageDefaultSupplierDto>(
            ReleaseDefaultInstallerDialogComponent,
            {
                data: {
                    mappedItem: this.mappedItem,
                    item: cloneDeepSafe(defaultInstaller)
                },
            }
        )
            .afterClosed()
            .pipe(take(1)).subscribe(result => {
                if (result) {
                    if (idx !== undefined && idx >= 0) {
                        this.mappedItem.defaultSuppliers[idx] = result;
                    } else {
                        this.mappedItem.defaultSuppliers.push(result);
                    }
                }
            });
    }

    public deleteClick(defaultInstaller: IProjectReleaseStageDefaultSupplierDto, idx: number): void {
        this.cbDialog.confirm({
            dialogHeading: 'Delete Default Installer',
            message: 'Are you sure you want to delete this Default Installer?',
            confirmed: () => {
                this.projectReleaseStagesLogicService.deleteDefaultInstaller(defaultInstaller.projectReleaseStageId, defaultInstaller.tradeType.id).pipe(take(1)).subscribe(_ => {
                    this.mappedItem.defaultSuppliers.splice(idx, 1);
                });
            }
        });
    }

    public addAll(): void {
        this.cbDialog.confirm({
            dialogHeading: 'Reset Default Installers',
            message: 'Are you sure you want to reset the default installers for this project release?',
            confirmed: () => {
                this.mappedItem.addAllDefaultInstallers(this.mappedItem.id).pipe(take(1)).subscribe((defaultInstallers) => {
                    this.mappedItem.defaultSuppliers = defaultInstallers;
                });
            }
        });
    }

}
